<template>
  <div class="card">
    <h6>SUPPLIER CONSENTS</h6>
    <supplier-specific-terms-british-gas
      :v="$v"
      v-if="supplierId == 2"
    ></supplier-specific-terms-british-gas>
    <supplier-specific-terms-eon
      :v="$v"
      v-else-if="supplierId == 4"
    ></supplier-specific-terms-eon>
    <supplier-specific-terms-eon-next
      :v="$v"
      v-else-if="supplierId == 111"
    ></supplier-specific-terms-eon-next>
    <supplier-specific-terms-edf
      :v="$v"
      v-else-if="supplierId == 7"
    ></supplier-specific-terms-edf>
    <supplier-specific-terms-shell-energy
      :v="$v"
      v-else-if="supplierId == 8"
    ></supplier-specific-terms-shell-energy>
    <supplier-specific-terms-ovo
      :v="$v"
      v-else-if="supplierId == 12"
    ></supplier-specific-terms-ovo>
    <supplier-specific-terms-utilita
      :v="$v"
      v-else-if="supplierId == 22"
    ></supplier-specific-terms-utilita>
    <supplier-specific-terms-pfp-energy
      :v="$v"
      v-else-if="supplierId == 42"
    ></supplier-specific-terms-pfp-energy>
    <supplier-specific-terms-octopus-energy
      :v="$v"
      v-else-if="supplierId == 49"
    ></supplier-specific-terms-octopus-energy>
    <supplier-specific-terms-so-energy
      :v="$v"
      v-else-if="supplierId == 43"
    ></supplier-specific-terms-so-energy>
    <supplier-specific-terms-rebel-energy
      :v="$v"
      v-else-if="supplierId == 116"
    ></supplier-specific-terms-rebel-energy>
    <supplier-specific-terms-fuse-energy
      :v="$v"
      v-else-if="isFuse"
    ></supplier-specific-terms-fuse-energy>

    <supplier-specific-terms-default
      :v="$v"
      v-else
    ></supplier-specific-terms-default>
  </div>
</template>

<script>
import SupplierSpecificTerms from "../../../../base/components/supplier-specific-terms";
import SupplierSpecificTermsDefault from "./SupplierSpecificTermsDefault";

import { mapState } from "vuex";

export default {
  name: "SupplierTerms",
  props: {
    $form: Object,
    $v: Object,
  },
  computed: {
    ...mapState({
      supplierId: ({ personal_details_switch_plan }) =>
        personal_details_switch_plan.supplierId,
      supplierName: ({ personal_details_switch_plan }) =>
        personal_details_switch_plan.supplierName,
      terms: ({ personal_details_terms }) => personal_details_terms,
      specialNeedsList: ({ lookups }) => lookups.specialNeeds,
    }),
    // Match by name until Fuse supplierId is confirmed with Senthil
    isFuse() {
      return /fuse/i.test(this.supplierName || "");
    },
  },
  methods: {
    onChangeSpecialNeeds() {
      if (this.terms.hasMedicalConditionOrIndividualRequirement) {
        this.$store.dispatch("lookups/getSpecialNeedsList");
      } else {
        this.terms.specialNeedsId = null;
      }
    },
  },
  components: {
    ...SupplierSpecificTerms,
    // UT-local default: no Mobile / Evening Telephone / Day Telephone / Email / Post / SMS / Face to Face
    SupplierSpecificTermsDefault,
  },
};
</script>

<style lang="scss"></style>
